import * as i from "../../../contracts";

export const mapHasLiveStreaming = (league: i.League) => {
    league.hasLiveStreaming = (league.tags && league.tags.indexOf("LiveStreaming") >= 0) || false;
};